import { parseScheduleDateTime } from './scheduleTimeZone';

/** Default session length after kickoff (must match backend app.practice.default-duration-minutes). */
export const DEFAULT_PRACTICE_DURATION_MS = 120 * 60 * 1000;

export function getPracticeEndDate(practice) {
  if (!practice?.practiceDate) return null;
  if (practice.practiceEndDate) {
    return parseScheduleDateTime(practice.practiceEndDate);
  }
  const start = parseScheduleDateTime(practice.practiceDate);
  return start ? new Date(start.getTime() + DEFAULT_PRACTICE_DURATION_MS) : null;
}

export function isPracticeSessionEnded(practice) {
  if (!practice) return false;
  if (practice.status === 'COMPLETED') return true;
  if (practice.status === 'CANCELLED') return false;
  const end = getPracticeEndDate(practice);
  return end ? end < new Date() : false;
}

/** True once kickoff (practiceDate) has passed in the app schedule zone. */
export function hasPracticeKickoffStarted(practice) {
  if (!practice?.practiceDate) return false;
  const start = parseScheduleDateTime(practice.practiceDate);
  return start ? start <= new Date() : false;
}

export function canEditPracticeAvailability(practice) {
  if (!practice) return false;
  if (practice.status === 'CANCELLED' || practice.status === 'COMPLETED') return false;
  return !isPracticeSessionEnded(practice);
}

/** Team formation and roster edits are allowed until kickoff. */
export function canFormOrEditTeams(practice) {
  if (!practice) return false;
  if (practice.status === 'CANCELLED' || practice.status === 'COMPLETED') return false;
  return !hasPracticeKickoffStarted(practice);
}

/** Club admins/coordinators can record or fix scrimmage stats after practice ends (including COMPLETED). */
export function canManageScrimmageStats(practice) {
  if (!practice) return false;
  return practice.status !== 'CANCELLED';
}

export function isUpcomingPractice(practice) {
  if (!practice?.practiceDate) return false;
  if (practice.status === 'CANCELLED' || practice.status === 'COMPLETED') return false;
  return !isPracticeSessionEnded(practice);
}

export function sortUpcomingPractices(practices) {
  if (!Array.isArray(practices)) return [];
  return practices
    .filter(isUpcomingPractice)
    .sort((a, b) => {
      const aStart = parseScheduleDateTime(a.practiceDate);
      const bStart = parseScheduleDateTime(b.practiceDate);
      if (!aStart || !bStart) return 0;
      return aStart - bStart;
    });
}
